import type { ModalData } from '@presentation/components/Modal';
import type { FormikConfig } from 'formik';

export interface ChangePasswordModalFormValues {
  password: string;
  confirmPassword: string;
}

export interface ChangePasswordModalData {
  modal: ModalData;
  form: {
    initialValues: ChangePasswordModalFormValues;
    onSubmit: FormikConfig<ChangePasswordModalFormValues>['onSubmit'];
    validationSchema: FormikConfig<ChangePasswordModalFormValues>['validationSchema'];
  };
}

export interface ChangePasswordModalProps extends ChangePasswordModalData {}
